module.exports = __webpack_public_path__ + "52a9357c0b4c8b2a1e2ff5b0c5e850f5.png";